import { AxiosPromise } from 'axios';
import { csttFacadeApi } from '@cd/sdds-common-components-react';

const createDocsUser = (payload: DocsUserType): AxiosPromise<any> => csttFacadeApi.post('/csttfacade/docs/v1/user', payload)

export { createDocsUser }